module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAUCAYAAAD/Rn+7AAAA+klEQVR42u3WvwqCUBQG8PseDb2RDdHS0GwQbUEQFBlESIIEDvUCbUGLg9Ik1BKIuxaamhZR0Z+h5QvX7uhyhoaz/zjnnnM/9glDnDQNl/kc18UCvihiyxiZYs/NBlG3i0SWcZ7N6AHvpolEURD3+1kn6QHfjoNDq4XjcIh0MqEHvC6XSFUV+1oNsSTRA75sG0GziajXy0ZN8A0aBpxCAa4gwKtU6AFvug6vXIZbKmVFs4NRp4Og0UAyHtMDPiwLu2oVfr2ebfMfmHfE/yXJfWZGq7ZXlNiaSnGHWrREsCkjUr9f3WBADMiHBWJAPm4RA/KBlRyQi/zUgF+qMdN+WrEm7wAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./client/src/images/flags/by.png
// module id = 788
// module chunks = 0